import * as React from 'react';
import treatmentsReducer from './treatmentsReducer.js';
import { TreatmentsContext } from './treatmentsContext.js';

function TreatmentsProvider({ children }) {
  
  const [state, dispatch] = React.useReducer(treatmentsReducer, {
    allTreatments: [],
    allTreatmentMessages: [],
    treatmentCollaborators: [],
    treatmentDocuments: [],
    treatmentConversation: {},
    treatmentMessages: {},
    treatmentTransactions: {
      paid: [],
      unpaid: []
    }
  });

  const value = [state, dispatch];

  return (
    <TreatmentsContext.Provider value={value}>
      { children }
    </TreatmentsContext.Provider>
  )
}

export default TreatmentsProvider;

